/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Checkpoint_LabelInputs */



/**
* | output |
* | --- |
* | "Checkpoint" |
*
* @param {Assistant_Checkpoint_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_checkpoint_label = /** @type {((inputs?: Assistant_Checkpoint_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Checkpoint_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Point de contrôle")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kontrollpunkt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Checkpoint")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Контрольно-пропускной пункт")
	if (locale === "es") return /** @type {LocalizedString} */ ("Control")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("检查点")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チェックポイント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("जांच की चौकी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ponto de verificação")
	return /** @type {LocalizedString} */ ("Checkpoint")
});